import { setHeaderHeightVariable } from './modules/set-header-height-variable.js';
import { setViewportWidthVariable } from './modules/set-viewport-width-variable.js';
import { delayedScroll } from './modules/delayed-scroll.js';
import { disableTelOnPC } from './modules/disable-tel-on-pc.js';
import { modal } from './modules/modal.js';
import { contactModal } from './modules/contact-modal.js';
import { tabs } from './modules/tabs.js';
import { accordion } from './modules/accordion.js';
import { contactFormConfirm, initBirthDateClamp } from './modules/contact-form-confirm.js';
import { postalCodeLookup } from './modules/postal-code-lookup.js';
import { scrollAnimation } from './modules/scroll-animation.js';
import { fileDrop } from './modules/file-drop.js';
import { mvAnimation } from './modules/mv-animation.js';

/**
 * メインJavaScript - 各モジュールの初期化
 */
document.addEventListener('DOMContentLoaded', () => {
  setHeaderHeightVariable();
  setViewportWidthVariable();
  delayedScroll();
  disableTelOnPC();
  modal();
  contactModal();
  tabs();
  accordion();
  contactFormConfirm();
  initBirthDateClamp();
  postalCodeLookup();
  scrollAnimation();
  fileDrop();
  mvAnimation();
});
